/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-debugger */
import { useState, useEffect } from 'react';
// material
import { Card, Container } from '@material-ui/core';
import useSettings from 'src/hooks/useSettings';
import TableSearch from 'src/components/table/TableSearch';
import { PROJECT_LIST_HEAD } from 'src/constants/Dashboard';
import { useSnackbar } from 'notistack5';
// redux
import {
  deleteProject,
  filterProject,
  statusChange,
  resetCreateProjectStatus,
  resetProjectMsg
} from 'src/redux/slices/project';
import { useDispatch, useSelector } from 'src/redux/store';
import AlertDialog from 'src/components/common-components/AlertDialog';

// ----------------------------------------------------------------------

export default function ProjectList({
  setEditId,
  deleteId,
  setDeleteId,
  projectList,
  setProjectListStatus,
  ProjectListStatus,
  loading
}) {
  const { themeStretch } = useSettings();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [title, setTiltle] = useState('');
  const [content, setContent] = useState('');
  const dispatch = useDispatch();
  const { createProjectStatus, projectMsg } = useSelector((state) => state.project);

  useEffect(() => {
    if (createProjectStatus) {
      enqueueSnackbar('Project Disabled Successfully', { variant: 'success' });
      dispatch(resetCreateProjectStatus());
    }
    if (projectMsg) {
      setClose(true);
      setOpen(true);
      dispatch(resetProjectMsg());
      setTiltle('Disable Project');
      setContent(projectMsg);
    }
  }, [projectMsg, createProjectStatus]);

  const handleProjectListSwitch = (e) => {
    setProjectListStatus(!e.target.checked);
  };
  const handleDelete = (id) => {
    setClose(false);
    setTiltle('Delete Project?');
    setContent('Are you sure want to delete Project data permanently??');
    setOpen(true);
    setDeleteId(id);
  };

  const handleDeleteDispatch = () => {
    dispatch(deleteProject(deleteId));
    enqueueSnackbar('Project Deleted Successfully', {
      variant: 'success'
    });
    setOpen(false);
  };

  const handleEdit = (id) => {
    setEditId(id);
  };

  const handleDisable = (id) => {
    dispatch(statusChange(id, false));
  };

  const handleRestore = async (id) => {
    dispatch(statusChange(id, true));
    enqueueSnackbar('Project Restore Successfully', {
      variant: 'success'
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Container maxWidth={themeStretch ? false : 'lg'} style={{ padding: 0 }}>
      <Card>
        <AlertDialog
          title={title}
          content={content}
          okFunction={close ? handleClose : handleDeleteDispatch}
          open={open}
          setOpen={setOpen}
        />
        <TableSearch
          tableHead={PROJECT_LIST_HEAD}
          tableData={projectList}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleDisable={handleDisable}
          handleRestore={handleRestore}
          status={ProjectListStatus}
          switchButton
          filterComponent={filterProject}
          switchButtonResponse={handleProjectListSwitch}
          loading={loading}
        />
      </Card>
    </Container>
  );
}
